import { useTranslation } from 'react-i18next';

import type { BlackbaudRaisersEdgeIntegration } from '@feathr/blackbox';
import type { IIntegrationUIOption } from '@feathr/components';
import { toast } from '@feathr/components';
import { errorMessage } from '@feathr/hooks';

import { useLazyOptions } from '../../useLazyOptions';

/** The integration's Blackbaud funds as select options, loaded the first time `enabled` is true. */
export function useFundOptions(
  integration: BlackbaudRaisersEdgeIntegration,
  enabled: boolean,
): readonly IIntegrationUIOption[] | undefined {
  const { t } = useTranslation();

  async function load(): Promise<IIntegrationUIOption[]> {
    const response = await integration.getFunds();
    return (response?.funds ?? []).map(({ description, id }) => ({ id, name: description }));
  }

  function handleError(error: unknown): void {
    toast(t('Failed to load funds:\n{{- error}}', { error: errorMessage(error, t) }), {
      type: 'error',
    });
  }

  return useLazyOptions({ enabled, load, onError: handleError });
}
